var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'syf-component-library/ui/atoms/Link';
var SamsLink = function (_a) {
    var children = _a.children, icon = _a.icon, className = _a.className;
    return (_jsx(Link, __assign({ "data-analytics": "clicktrackingevent", "data-object": "link", "data-type": "samsclub.com", "data-cy": "sams-link", href: "https://www.samsclub.com/account/cardholders?xid=account_additional-cardholders", isInline: true, rel: "noopener noreferrer", target: "_blank", icon: icon, className: className }, { children: children })));
};
export default SamsLink;
